import React, { useState } from "react";
import { Modal as AntModal } from "antd";
import styled from "@emotion/styled";


const ModalBody = styled.div`
  .form-row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
    margin-bottom: 16px;
    @media (max-width: 576px) { grid-template-columns: 1fr; }
  }
  .form-row-single {
    display: grid;
    grid-template-columns: 1fr;
    gap: 16px;
    margin-bottom: 16px;
  }
  .form-group {
    display: flex;
    flex-direction: column;
    gap: 6px;
    label {
      font-size: 13px;
      font-weight: 500;
      color: #333;
      .required { color: red; margin-left: 2px; }
    }
  }
  select, input[type="text"], input[type="number"], input[type="time"] {
    border: 1px solid #d9d9d9;
    border-radius: 6px;
    padding: 6px 10px;
    font-size: 14px;
    outline: none;
    width: 100%;
    box-sizing: border-box;
    font-family: inherit;
    &:focus { border-color: #00c48c; }
  }
  textarea {
    border: 1px solid #d9d9d9;
    border-radius: 6px;
    padding: 10px;
    font-size: 14px;
    resize: vertical;
    min-height: 90px;
    outline: none;
    font-family: inherit;
    width: 100%;
    box-sizing: border-box;
    &:focus { border-color: #00c48c; }
  }
  .rate-row {
    display: flex;
    align-items: center;
    border: 1px solid #d9d9d9;
    border-radius: 6px;
    overflow: hidden;
    .currency-symbol {
      padding: 0 10px;
      background: #f5f5f5;
      border-right: 1px solid #d9d9d9;
      font-size: 14px;
      color: #555;
      height: 34px;
      display: flex;
      align-items: center;
      white-space: nowrap;
    }
    input {
      border: none !important;
      border-radius: 0 !important;
      outline: none;
      padding: 0 10px;
      flex: 1;
      font-size: 14px;
      height: 34px;
    }
  }
  .description-toolbar {
    display: flex;
    align-items: center;
    gap: 4px;
    border: 1px solid #d9d9d9;
    border-bottom: none;
    border-radius: 6px 6px 0 0;
    padding: 6px 10px;
    background: #fafafa;
    button {
      background: none;
      border: none;
      cursor: pointer;
      font-size: 13px;
      font-weight: bold;
      color: #555;
      padding: 2px 5px;
      border-radius: 3px;
      &:hover { background: #ebebeb; }
    }
    .separator { width: 1px; height: 16px; background: #d9d9d9; margin: 0 4px; }
  }
  textarea.desc-area {
    border-radius: 0 0 6px 6px;
    border-top: none;
  }
  .upload-btn {
    display: flex;
    align-items: center;
    gap: 8px;
    background: #c6f4e7;
    border: none;
    border-radius: 6px;
    padding: 8px 20px;
    font-size: 14px;
    cursor: pointer;
    font-weight: 500;
    width: fit-content;
  }
  .radio-group {
    display: flex;
    align-items: center;
    gap: 16px;
    padding-top: 4px;
    label {
      display: flex;
      align-items: center;
      gap: 6px;
      font-size: 14px;
      font-weight: 400;
      cursor: pointer;
    }
    input[type="radio"] {
      width: 16px;
      height: 16px;
      accent-color: #00c48c;
      border: none;
      padding: 0;
    }
  }
  .checkbox-label {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    cursor: pointer;
    input[type="checkbox"] {
      width: 18px;
      height: 18px;
      accent-color: #00c48c;
      border: none;
      padding: 0;
    }
  }
  .section-title {
    font-size: 15px;
    font-weight: 600;
    margin: 8px 0 12px;
    color: #222;
  }
  .tag-input-row {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    align-items: center;
    border: 1px solid #d9d9d9;
    border-radius: 6px;
    padding: 6px 10px;
    min-height: 38px;
    .tag {
      display: flex;
      align-items: center;
      gap: 4px;
      background: #f0f0f0;
      border-radius: 4px;
      padding: 2px 8px;
      font-size: 13px;
      button {
        background: none;
        border: none;
        cursor: pointer;
        font-size: 12px;
        color: #888;
        padding: 0;
        line-height: 1;
      }
    }
    select {
      border: none !important;
      padding: 0 !important;
      flex: 1;
      min-width: 80px;
      font-size: 13px;
      outline: none;
    }
  }
  .infobox {
    background: #f5f5f5;
    border-radius: 8px;
    padding: 14px 16px;
    margin-bottom: 16px;
    .form-row { margin-bottom: 0; }
  }
`;

const ModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
  .btn-cancel {
    padding: 8px 24px;
    border: 1px solid #d9d9d9;
    border-radius: 6px;
    background: #fff;
    cursor: pointer;
    font-size: 14px;
  }
  .btn-create {
    padding: 8px 24px;
    border: none;
    border-radius: 6px;
    background: #c6f4e7;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
  }
`;

const DescriptionBlock = ({ value, onChange }) => (
  <>
    <div className="description-toolbar">
      <button><b>B</b></button>
      <button><i>I</i></button>
      <button><u>U</u></button>
      <button><s>S</s></button>
      <div className="separator" />
      <button>1.</button>
      <button>•</button>
      <div className="separator" />
      <button>🔗</button>
    </div>
    <textarea className="desc-area" value={value} onChange={e => onChange(e.target.value)} />
  </>
);

const TaskModal = ({ visible, onClose }) => {
  const [taskName, setTaskName] = useState("Advisory Proposal");
  const [priority, setPriority] = useState("High");
  const [assignTo, setAssignTo] = useState("James");
  const [isPrivate, setIsPrivate] = useState(true);
  const [taskType, setTaskType] = useState("ABC");
  const [taskStatus, setTaskStatus] = useState("Open");
  const [matter, setMatter] = useState("Advisory");
  const [estTime, setEstTime] = useState("");
  const [dueDate, setDueDate] = useState("05th March 2025");
  const [dueTime, setDueTime] = useState("10:00 AM");
  const [description, setDescription] = useState("");

  return (
    <AntModal title="Creating Task" open={visible} onCancel={onClose} footer={null} width={700} destroyOnClose>
      <ModalBody>
        <div className="form-row">
          <div className="form-group">
            <label>Name of the Task</label>
            <input type="text" value={taskName} onChange={e => setTaskName(e.target.value)} />
          </div>
          <div className="form-group">
            <label>Priority</label>
            <select value={priority} onChange={e => setPriority(e.target.value)}>
              <option>High</option><option>Medium</option><option>Low</option>
            </select>
          </div>
        </div>
        <div className="form-row">
          <div className="form-group">
            <label>Assign to</label>
            <select value={assignTo} onChange={e => setAssignTo(e.target.value)}>
              <option>James</option><option>Alice</option><option>Bob</option>
            </select>
          </div>
          <div className="form-group">
            <label>Task Privacy</label>
            <label className="checkbox-label">
              <input type="checkbox" checked={isPrivate} onChange={e => setIsPrivate(e.target.checked)} />
              Mark it Private
            </label>
          </div>
        </div>
        <div className="form-row">
          <div className="form-group">
            <label>Task Type</label>
            <select value={taskType} onChange={e => setTaskType(e.target.value)}>
              <option>ABC</option><option>DEF</option>
            </select>
          </div>
          <div className="form-group">
            <label>Task Status</label>
            <select value={taskStatus} onChange={e => setTaskStatus(e.target.value)}>
              <option>Open</option><option>In Progress</option><option>Closed</option>
            </select>
          </div>
        </div>
        <div className="form-row">
          <div className="form-group">
            <label>Matter</label>
            <select value={matter} onChange={e => setMatter(e.target.value)}>
              <option>Advisory</option><option>Legal</option>
            </select>
          </div>
          <div className="form-group">
            <label>Estimated Time of Completion (optional)</label>
            <input type="text" value={estTime} onChange={e => setEstTime(e.target.value)} placeholder="Eg: 2 hrs 20 mins" />
          </div>
        </div>
        <div className="form-row">
          <div className="form-group">
            <label>Due Date</label>
            <input type="text" value={dueDate} onChange={e => setDueDate(e.target.value)} />
          </div>
          <div className="form-group">
            <label>Due Time</label>
            <input type="text" value={dueTime} onChange={e => setDueTime(e.target.value)} placeholder="10:00 AM" />
          </div>
        </div>
        <div className="form-group" style={{ marginBottom: 4 }}>
          <label>Task Description</label>
          <DescriptionBlock value={description} onChange={setDescription} />
        </div>
        <ModalFooter>
          <button className="btn-cancel" onClick={onClose}>Cancel</button>
          <button className="btn-create" onClick={onClose}>Create</button>
        </ModalFooter>
      </ModalBody>
    </AntModal>
  );
};

export default TaskModal;